// CustomDropdown.js
import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './CustomDropdown.css';

const CustomDropdown = ({ options, value, onChange, placeholder = "Выберите..." }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);

  // Закрытие при клике вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (triggerRef.current && !triggerRef.current.contains(event.target) &&
          dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => opt.value === value);

  // Рендерим выпадающее меню через портал
  const renderDropdownMenu = () => {
    if (!isOpen) return null;

    const triggerRect = triggerRef.current.getBoundingClientRect();
    
    return ReactDOM.createPortal(
      <div 
        ref={dropdownRef}
        className="dropdown-menu portal-dropdown"
        style={{
          position: 'fixed',
          top: triggerRect.bottom + window.scrollY,
          left: triggerRect.left + window.scrollX,
          width: triggerRect.width,
          zIndex: 9999
        }}
      >
        {options.map(option => (
          <div
            key={option.value}
            className={`range-option-drop ${value === option.value ? 'selected' : ''}`}
            onClick={() => {
              onChange(option.value);
              setIsOpen(false);
            }}
          >
            {option.icon && <i className={option.icon}></i>}
            <span>{option.label}</span>
          </div>
        ))}
      </div>,
      document.body
    );
  };

  return (
    <div className="custom-dropdown">
      <div
        ref={triggerRef}
        className={`dropdown-trigger ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="selected-value">
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <i className="dropdown-arrow fas fa-chevron-down"></i>
      </div>
      {renderDropdownMenu()}
    </div>
  );
};

export default CustomDropdown;